/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('projects.replaceCards', function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            var target = document.querySelector('.projects__overview .card__container');
            target.classList.add('loading');
            var current = e.target;
            if (!current.classList.contains('btn-primary')) {
                MoyaContainer.get('core.fetch').fetchAndReplace({
                    url: button.dataset.url,
                }, target).then(function (el) {
                    el.classList.remove('loading');
                    var box = el.closest('.box');
                    if (box) {
                        box.scrollIntoView({ behavior: 'smooth' });
                    }
                });
                current.parentElement.parentElement.querySelectorAll('.btn-primary').forEach(function (e) {
                    e.classList.remove('btn-primary');
                    e.classList.add('btn-white');
                });
                current.classList.add('btn-primary');
                current.classList.remove('btn-white');
            }
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
